import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import * as moment from 'moment';
import { faLockOpen, faLock, faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { DxDataGridComponent } from "devextreme-angular";
import { UserService } from '../../services/user.service';
import { EmployeePortalService } from '../../../modules/employee/_api/services/employee-portal.service';
import { LanguageService } from '../../services/language.service';

@Component({
  selector: 'app-grid-timelist',
  templateUrl: './grid-timelist.component.html',
  styleUrls: ['./grid-timelist.component.css']
})
export class GridTimelistComponent implements OnInit {

  @ViewChild(DxDataGridComponent, {static: false}) dataGrid: DxDataGridComponent;
  @Input() selectedEmployeeId: number = -1;
  @Input() showEmployeeSelect: boolean = true;
  @Input() showEmployeeColumn: boolean = true;
  @Input() employeeDataSource: any[];
  @Input() labelConfirmed: string;
  @Input() labelTransferred: string;
  dataSource: any;
  @Output() loading = new EventEmitter<boolean>();//emit event to parent(employee-portal.component) to show load indicator
  @Output() emitDataSource = new EventEmitter<any>();//emit event to parent to tell that datasource is changed
  @Output() emitSearchCriterias = new EventEmitter<any>();//emit event to parent to tell that searchcriteras are changed

  @Input() categoryStatusCombos: any[];
  @Input() projectIds: any[] = [];
  @Input() maxStatusIdLockOpen: number = -1;
  @Input() minStatusIdLock: number = -1;
  @Input() maxStatusIdLock: number = -1;
  @Input() minStatusIdEnvelope: number = -1;
  @Input() maxStatusIdEnvelope: number = -1;
  @Input() limitEmployees: boolean = false;//limit to only retrieve time posts to the employees that are supervised by the user.
  @Input() showProjectActivityColumn: boolean = false;
  @Input() showTimeTypeCategoryColumn: boolean = true;
  // @Input() selectedProject: any;
  @Input() motherProjectName: string = "";
  @Input() customerName: string = "";
  @Input() showCustomerColumn: boolean = false;
  isLoading: boolean = false; 

  statuses: any;
  selectedDateRangeIndex: number = 0;//index in app-date-selector
  initDate: any;
  from: string;
  to: string;
  labels = {
    Unconfirmed: '',
    UnconfirmedTransport: '',
    Confirmed: '',
    Approved: '',
    ReadyToSalary: '',
    TransferredToSalary: '',
  };
  textProjectActivityNumber = "";
  textProjectActivityName = "";
  placeholderEmployeeSelect = "";
  faLockOpen = faLockOpen;
  faLock = faLock;
  faEnvelope = faEnvelope;
  statusFilterData = [];
  searchCriterias: any = {
    selectedDateRangeIndex: 0,
    fromDate: "",
    toDate: "",
    selectedEmployeeId: -1,
  };

  // selectedProject: any = {};

  constructor(private userService: UserService, private employeePortalService: EmployeePortalService, public languageService: LanguageService) {
    this.customizeExport = this.customizeExport.bind(this);
   }

  ngOnInit() {


    this.initDate = moment();
    this.from = moment().format("DD.MM.YYYY");
    this.to = moment().format("DD.MM.YYYY");
    this.labels.Approved = this.languageService.LNG("Label.Is.Approved");
    this.labels.Unconfirmed = this.languageService.LNG("Label.Unconfirmed");
    this.labels.UnconfirmedTransport = this.languageService.LNG("Label.Unconfirmed") + " " + this.languageService.LNG("Label.Transport");
    this.labels.Confirmed = !this.labelConfirmed ? this.languageService.LNG("Label.Confirmed") : this.labelConfirmed;
    this.labels.ReadyToSalary = this.languageService.LNG("Label.Ready.For.Salary");
    this.labels.TransferredToSalary = !this.labelTransferred ? this.languageService.LNG("Label.Transferred.Salary") : this.labelTransferred;
    this.textProjectActivityNumber = this.languageService.LNG("Label.Project.Activity") + this.languageService.LNG("Label.Nr").toLowerCase();
    this.textProjectActivityName = this.languageService.LNG("Label.Project.Activity") + this.languageService.LNG("Label.Name").toLowerCase();
    this.placeholderEmployeeSelect = this.languageService.LNG("Label.Employee");
    this.loadTimes(true, false);
    this.statusFilterData = [];
    this.statuses = this.removeDuplicates(this.categoryStatusCombos, "StatusId");

    this.statuses.forEach(combo => {

      //Eirik 01.02.21 task 876 - when ShowEqualOrLargerThanStatus is set, then show the filters as well
      if (combo.ShowEqualOrLargerThanStatus) {
        this.statusesGreaterThanOrEqual(combo.StatusId);
      }
      else {
        switch (combo.StatusId) {
          case 2:
            //if (!this.statusExist(this.labels.Unconfirmed)) {
              this.statusFilterData.push({
                text: this.labels.Unconfirmed,
                value: ["StatusId", "=", 2]
              });
            break;
          case 3:
              this.statusFilterData.push({
                text: this.labels.Confirmed,
                value: ["StatusId", "=", 3]
              });
            break;
          case 4:
              this.statusFilterData.push({
                text: this.labels.Approved,
                value: ["StatusId", "=", 4]
              });
            break;
          case 5:
              this.statusFilterData.push({
                text: this.labels.ReadyToSalary,
                value: ["StatusId", "=", 5]
              });
            break;
          case 99:
              this.statusFilterData.push({
                text: this.labels.TransferredToSalary,
                value: ["StatusId", "=", 99]
              });
            break;
          default:
            break;
        }
      }
      // });
    });

  }

  removeDuplicates(originalArray, prop) {
    var newArray = [];
    var lookupObject = {};

    for (var i in originalArray) {
      lookupObject[originalArray[i][prop]] = originalArray[i];
    }

    for (i in lookupObject) {
      newArray.push(lookupObject[i]);
    }
    return newArray;
  }

  statusesGreaterThanOrEqual(statusId: number) {
    if (statusId <= 2) {
      this.statusFilterData.push( {
        text: this.labels.Unconfirmed,
        value: ["StatusId", "=", 2]
      });
    }
    if (statusId <= 3) {
      this.statusFilterData.push( {
        text: this.labels.Confirmed,
        value: ["StatusId", "=", 3]
      });
    }
    if (statusId <= 4) {
      this.statusFilterData.push( {
        text: this.labels.Approved,
        value: ["StatusId", "=", 4]
      });
    }
    if (statusId <= 5) {
      this.statusFilterData.push( {
        text: this.labels.ReadyToSalary,
        value: ["StatusId", "=", 5]
      });
    }
    if (statusId <= 99) {
      this.statusFilterData.push( {
        text: this.labels.TransferredToSalary,
        value: ["StatusId", "=", 99]
      });
    }
  }

  initSearchParameters(iDateRangeIndex?: number, initDate?: any) {

    if (iDateRangeIndex != null) {
      this.selectedDateRangeIndex = iDateRangeIndex;
      // this.setSelectedDateRangeIndex = iDateRangeIndex;
    }
    if (initDate) {
      this.initDate = initDate;
      this.from = this.initDate.format("DD.MM.YYYY");
      this.to = this.initDate.format("DD.MM.YYYY");
    }
  }

  loadTimes(refreshSearchCriterias: boolean = true, showLoader: boolean = true) {
    if (showLoader) {
      this.loading.emit(true);
      this.isLoading = true; 
    }
    let user = this.userService.account;
    this.searchCriterias.selectedDateRangeIndex = this.selectedDateRangeIndex;
    this.searchCriterias.fromDate = this.from;
    this.searchCriterias.toDate = this.to;
    this.searchCriterias.selectedEmployeeId = this.selectedEmployeeId;
    this.emitSearchCriterias.emit(this.searchCriterias);

    this.employeePortalService.getListEmployeePortalAdmin_Combos(this.selectedEmployeeId, this.limitEmployees, this.from, this.to, user.IsAdmin, this.categoryStatusCombos, this.projectIds)
      .subscribe((result: any) => { // success path
        if (refreshSearchCriterias) {
          this.clearDataGridSelections();
        }
        this.dataSource = result.Data;
        this.emitDataSource.emit(result.Data);
        this.loading.emit(false);
        this.isLoading = false; 
      }, error => { // error path;
        this.loading.emit(false);
        this.isLoading = false; 
      });
  }


  clearDataGridSelections() {
    this.dataGrid.instance.clearFilter();
    this.dataGrid.instance.clearGrouping();
    this.dataGrid.instance.clearSelection();
    this.dataGrid.instance.clearSorting();
  }

  //show grouped date as "dddd DD.MM.YYYY". the date from dataField has format DD.MM.YYYY
  groupTemplate(data) {


    let date = data.value;
    // let dt = moment(date);
    let dt = moment(date, "YYYY-MM-DD");
    console.log("dt", dt);
    var nb = moment(dt).locale('nb');
    let dateDDMMYYYY = nb.format('dddd DD.MM.YYYY');
    return dateDDMMYYYY;
  }

  dateChanged(dateInterval: any) {

    if (dateInterval.FromDate !== null) {
      this.from = moment(dateInterval.FromDate).format("DD.MM.YYYY");
    }
    else {
      this.from = "01.01.0001";
    }
    this.to = moment(dateInterval.ToDate).format("DD.MM.YYYY");
    this.loadTimes(false);
  }

  //sort datestring as date
  customDateSort (rowData) {
    return rowData.Date;
  }

  onSelectionChangedEmployees(e) {

    if (e.selectedItem) {
      this.selectedEmployeeId = e.selectedItem.EmployeeId;
    }
    else {
      this.selectedEmployeeId = -1;
    }
    this.loadTimes(false);
  }


  calculateSummary(options) {
    // Calculating "customSummary1"
    if(options.name == "customSumHours") {
        switch(options.summaryProcess) {
            case "start":
                // Initializing "totalValue" here
                options.totalValue = 0;
                break;
            case "calculate":
                if (options.value.Seconds > 0)
                {
                  options.totalValue += options.value.Seconds;
                }
                // Modifying "totalValue" here
                break;
            case "finalize":
                // Assigning the final value to "totalValue" here
                let hours = options.totalValue / 3600;
                let min = (options.totalValue / 60) % 60;
                options.totalValue = Math.floor(hours) + "t " + Math.floor(min) + "min";
                break;
        }
    }
    if (options.name == "customSumHoursDecimal") {
      switch(options.summaryProcess) {
          case "start":
              // Initializing "totalValue" here
              options.totalValue = 0;
              break;
          case "calculate":
              if (options.value.Seconds > 0)
              {
                parseFloat
                options.totalValue += options.value.Seconds;
              }
              // Modifying "totalValue" here
              break;
          case "finalize":

              // Assigning the final value to "totalValue" here
              let hours = options.totalValue / 3600;
              let rounded = (Math.round(hours * 100) / 100).toFixed(2);
              // let min = (options.totalValue / 60) % 60;
              options.totalValue = rounded.replace(".", ",");
              break;
      }
    }
  }

  onCellPrepared(e) {
    if (e.rowType === "data") {
      if (e.columnIndex == 0) {

        switch (e.key.StatusId) {
          case 2:
            e.cellElement.title = this.labels.Unconfirmed;
            if (e.key.CategoryId == 7) {
              e.cellElement.title = this.labels.UnconfirmedTransport;
            }
            break;
          case 3:
            e.cellElement.title = this.labels.Confirmed;
            break;
          case 4:
            e.cellElement.title = this.labels.Approved;
            break;
          case 5:
            e.cellElement.title = this.labels.ReadyToSalary;
            break;
          case 99:
            e.cellElement.title = this.labels.TransferredToSalary;
            break;
          default:
            e.cellElement.style.backgroundColor = "#88B0C5"
            e.cellElement.title = "Udefinert Status";
            break;
        }
      }
    }
  }

  setInitDateNoLoad(initDate) {

    // this.loadOnDateChanged = false;
    this.initDate = initDate;
  }
  onExporting(e) {
    /*
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Liste');

    let startRow = 4;
    if (this.projectIds.length === 1) {
      startRow = 6;
    }

    exportDataGrid({
      component: e.component,
      worksheet: worksheet,
      topLeftCell: { row: startRow, column: 1 },
      customizeCell: function(options) {

        // See for more details:
        // - https://github.com/exceljs/exceljs#styles
        // - https://github.com/exceljs/exceljs#number-formats

        if(options.gridCell.rowType === 'data') {
          if(options.gridCell.column.dataField === 'TotSecondsAsHours') {
            options.excelCell.numFmt = '0.00';
          }
        }
      }
    }).then((xtra) => {

    // }).then((xtra) => function(dataGridRange) {
      // header
      // https://github.com/exceljs/exceljs#rows
      // const headerRow = worksheet.getRow(2);
      // headerRow.height = 30;
      // // https://github.com/exceljs/exceljs#merged-cells
      // worksheet.mergeCells(2, 1, 2, 8);

      // // https://github.com/exceljs/exceljs#value-types
      // headerRow.getCell(1).value = xtra.from + " - " + xtra.to;
      // // https://github.com/exceljs/exceljs#fonts
      // headerRow.getCell(1).font = { name: 'Segoe UI Light', size: 22 };
      // // https://github.com/exceljs/exceljs#alignment
      // headerRow.getCell(1).alignment = { horizontal: 'center' };

      this.customizeExport(worksheet).then(() => {

        return Promise.resolve();
      })

      // footer
      // const footerRowIndex = dataGridRange.to.row + 2;
      // const footerRow = worksheet.getRow(footerRowIndex);
      // worksheet.mergeCells(footerRowIndex, 1, footerRowIndex, 8);

      // footerRow.getCell(1).value = 'www.wikipedia.org';
      // footerRow.getCell(1).font = { color: { argb: 'BFBFBF' }, italic: true };
      // footerRow.getCell(1).alignment = { horizontal: 'right' };

    }).then(function() {
      // https://github.com/exceljs/exceljs#writing-xlsx
      workbook.xlsx.writeBuffer().then(function(buffer) {
        saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'Historikkliste.xlsx');
      });
    });
    e.cancel = true;*/
  }

  customizeExport(worksheet): Promise<void> {


    const headerRow1 = worksheet.getRow(2);
    headerRow1.height = 30;
    // https://github.com/exceljs/exceljs#merged-cells
    worksheet.mergeCells("A2:F2");

    if (this.projectIds.length === 1) {
      let customername = this.customerName;
      // let motherProjectNumber = this.selectedProject.MotherProjectNumber ? this.selectedProject.MotherProjectNumber : "";
      let motherProjectName = this.motherProjectName ? this.motherProjectName : "";
      headerRow1.getCell(1).value = this.languageService.LNG("Label.Customer") + ": " + customername;
      worksheet.mergeCells("A3:F3");
      if (motherProjectName.length > 0) {
        const headerRow2 = worksheet.getRow(3);
        headerRow2.getCell(1).value = this.languageService.LNG("Label.MainProject") + ": " + motherProjectName;
        headerRow2.getCell(1).font = { name: 'Segoe UI Light', size: 22 };
        headerRow2.getCell(1).alignment = { horizontal: 'center' };
      }
      worksheet.mergeCells("A4:F4");
      const headerRow3 = worksheet.getRow(4);
      headerRow3.getCell(1).value = this.from + " - " + this.to;
      headerRow3.getCell(1).font = { name: 'Segoe UI Light', size: 16 };
      headerRow3.getCell(1).alignment = { horizontal: 'center' };
    }
    else {
    // https://github.com/exceljs/exceljs#value-types
      headerRow1.getCell(1).value = this.from + " - " + this.to;
    }
    // https://github.com/exceljs/exceljs#fonts
    headerRow1.getCell(1).font = { name: 'Segoe UI Light', size: 22 };
    // https://github.com/exceljs/exceljs#alignment
    headerRow1.getCell(1).alignment = { horizontal: 'center' };

    // footer
    // const footerRowIndex = dataGridRange.to.row + 2;
    // const footerRow = worksheet.getRow(footerRowIndex);
    // worksheet.mergeCells(footerRowIndex, 1, footerRowIndex, 8);

    // footerRow.getCell(1).value = 'www.wikipedia.org';
    // footerRow.getCell(1).font = { color: { argb: 'BFBFBF' }, italic: true };
    // footerRow.getCell(1).alignment = { horizontal: 'right' };

    return Promise.resolve();
  }

}
